type SetIsLatestVersion = (isLatest: boolean) => void | null;

const v2 = "v2";

class UIVersion {
	private _version = "";
	private _setVer?: SetIsLatestVersion;

	setVersion(version: string) {
		this._version = version;
		if (this._setVer) {
			this._setVer(this.isLatestVersion());
		}
	}

	isLatestVersion() {
		const versionInSession = sessionStorage.getItem("ui");
		if (versionInSession) return versionInSession == v2;
		return this._version === v2;
	}

	setIsLatestVersion(setVer: SetIsLatestVersion) {
		this._setVer = setVer;
	}
}

const uiVersion = new UIVersion();
export default uiVersion;
